import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '../views/home.vue'
import registered from '../views/registered'
import departmentInfo from '../views/departmentInfo'
import registeredDeta from '../views/registeredDeta'
import doctorDetails from '../views/doctorDetails'
import doctor from '../views/doctor'
import docFeedback from '../views/docFeedback'
import regConfirmation from '../views/regConfirmation'
import patient from '../views/patient'
import prescriptionList from '../views/prescriptionList'
import prescription from '../views/prescription'
import inpatient from '../views/inpatient'
import inpatientPayCost from '../views/inpatientPayCost'
import inpatientRecords from '../views/inpatientRecords'
import inpatientDeposit from '../views/inpatientDeposit'
import inpatientDeta from '../views/inpatientDeta'
import inpatientInfo from '../views/inpatientInfo'
import regQuery from '../views/regQuery'
import payCost from '../views/payCost'
import user from '../views/user'
import paymentRecordsList from '../views/paymentRecordsList'
import paymentRecords from '../views/paymentRecords'
import communicationList from '../views/communicationList'
import communication from '../views/communication'
import communicationDeta from '../views/communicationDeta'
import chatRoom from '../views/chatRoom'
import chatMessage from '../views/chatMessage'
import emLogin from '../views/emLogin'
import collection from '../views/collection'
import collectionDeta from '../views/collectionDeta'
import collectionScore from '../views/collectionScore'
import collectionRegistered from '../views/collectionRegistered'
import statistical from '../views/statistical'
import staOutpatient from '../views/staOutpatient'
import stainHospital from '../views/stainHospital'
import staIncome from '../views/staIncome'
import staOffice from '../views/staOffice'
import staReg from '../views/staReg'
import staHospital from '../views/staHospital'
import staIndex from '../views/staIndex'
import staDean from '../views/staDean'
import staSelf from '../views/staSelf'
import report from '../views/report'
import reportDeta from '../views/reportDeta'
import Inintroduce from '../views/Inintroduce'

Vue.use(VueRouter)

const routes = [
	{ path: '/HelloWorld', name: 'HelloWorld', component: HelloWorld ,meta:{title:'helloworld'}},
    { path: '/', name: 'home', component: home, meta:{title:'首页'} },//首页
	{ path: '/departmentInfo', name: 'departmentInfo', component: departmentInfo, meta:{title:'科室介绍'} },//挂号预约列表
    { path: '/registered', name: 'registered', component: registered, meta:{title:'挂号预约列表'} },//挂号预约列表
    { path: '/registeredDeta', name: 'registeredDeta', component: registeredDeta, meta:{title:'挂号预约列表详情'} },//挂号预约列表详情
    { path: '/doctorDetails', name: 'doctorDetails', component: doctorDetails, meta:{title:'挂号预约医生详情'} },//挂号预约医生详情
    { path: '/regConfirmation', name: 'regConfirmation', component: regConfirmation, meta:{title:'挂号确认'} },//挂号确认
    { path: '/regQuery', name: 'regQuery', component: regQuery, meta:{title:'预约挂号查询'} },//预约挂号查询
    { path: '/patient', name: 'patient', component: patient, meta:{title:'添加就诊人'} },//添加就诊人
    { path: '/prescriptionList', name: 'prescriptionList', component: prescriptionList, meta:{title:'处方列表'} },//处方列表
    { path: '/prescription', name: 'prescription', component: prescription, meta:{title:'就诊报告'} },//处方笺
    { path: '/payCost', name: 'payCost', component: payCost, meta:{title:'门诊缴费'} },//缴费
    { path: '/paymentRecordsList', name: 'paymentRecordsList', component: paymentRecordsList, meta:{title:'门诊缴费'} },//缴费记录
    { path: '/paymentRecords', name: 'paymentRecords', component: paymentRecords, meta:{title:'缴费订单详情'} },//缴费订单详情
    { path: '/user', name: 'user', component: user, meta:{title:'个人中心'} },//个人中心
    { path: '/prescription', name: 'prescription', component: prescription, meta:{title:'处方详情'} },//处方详情
    { path: '/inpatient', name: 'inpatient', component: inpatient, meta:{title:'住院服务'} },//住院服务
    { path: '/inpatientDeta', name: 'inpatientDeta', component: inpatientDeta, meta:{title:'住院清单详情'} },//住院清单
    { path: '/inpatientInfo', name: 'inpatientInfo', component: inpatientInfo, meta:{title:'住院清信息'} },//住院清单
    { path: '/inpatientPayCost', name: 'inpatientPayCost', component: inpatientPayCost, meta:{title:'住院押金'} },
    // { path: '/inpatientRecords', name: 'inpatientRecords', component: inpatientRecords, meta:{title:'住院押金'} },
    { path: '/inpatientDeposit', name: 'inpatientDeposit', component: inpatientDeposit, meta:{title:'住院缴费记录'} },
    { path: '/communicationList', name: 'communicationList', component: communicationList, meta:{title:'通讯录'} },//通讯录
    { path: '/communication', name: 'communication', component: communication, meta:{title:'通讯录'} },//通讯录
    { path: '/communicationDeta', name: 'communicationDeta', component: communicationDeta, meta:{title:'详情'} },//通讯录详情
    { path: '/chatRoom', name: 'chatRoom', component: chatRoom, meta:{title:'聊天室'} },//聊天室
    { path: '/chatMessage', name: 'chatMessage', component: chatMessage, meta:{title:'消息'} },//消息
    { path: '/emLogin', name: 'emLogin', component: emLogin, meta:{title:'员工登录'} },//员工登录
    { path: '/collection', name: 'collection', component: collection, meta:{title:'关注的医生'} },
    { path: '/collectionDeta', name: 'collectionDeta', component: collectionDeta, meta:{title:'收藏详情'} },
	{ path: '/collectionScore', name: 'collectionScore', component: collectionScore, meta:{title:'建议'} },
	{ path: '/collectionRegistered', name: 'collectionRegistered', component: collectionRegistered, meta:{title:'医生预约'} },
    { path: '/statistical', name: 'statistical', component: statistical, meta:{title:'统计'} },//统计
	
	{ path: '/staOutpatient', name: 'staOutpatient', component: staOutpatient, meta:{title:'门诊'} },//门诊
	{ path: '/stainHospital', name: 'stainHospital', component: stainHospital, meta:{title:'住院'} },//住院
    // { path: '/staIncome', name: 'staIncome', component: staIncome, meta:{title:'收入情况'} },
    // { path: '/staOffice', name: 'staOffice', component: staOffice, meta:{title:'科室数据'} },
    // { path: '/staReg', name: 'staReg', component: staReg, meta:{title:'挂号数据'} },
    // { path: '/staHospital', name: 'staHospital', component: staHospital, meta:{title:'住院数据'} },
    // { path: '/staIndex', name: 'staIndex', component: staIndex, meta:{title:'医院报表'} },
    // { path: '/staDean', name: 'staDean', component: staDean, meta:{title:'院长报表'} },
    // { path: '/staSelf', name: 'staSelf', component: staSelf, meta:{title:'个人报表'} },
    { path: '/report', name: 'report', component: report, meta:{title:'报告'} },
    { path: '/reportDeta', name: 'reportDeta', component: reportDeta, meta:{title:'报告详情'} },
    { path: '/Inintroduce', name: 'Inintroduce', component: Inintroduce, meta:{title:'医院介绍'} },
	{ path: '/doctor', name: 'doctor', component: doctor, meta:{title:'医生'} },
	{ path: '/docFeedback', name: 'docFeedback', component: docFeedback, meta:{title:'对我的建议'} },
  
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
